import {Grup} from "./Grup";

export type Dubte = {
    id: number;
    id_usuari: number;
    nom: string;
    cognoms: string;
    total: number;
    consulta: string;
    atencio: string;
    exercici: number;
    dubte: string;
};

export const defaultDubte: Dubte = {
    id: 0,
    id_usuari: 0,
    nom: '',
    cognoms: '',
    total: 0,
    consulta: '',
    atencio: '',
    exercici: 0,
    dubte: ''
};
